import axios from "axios";
import { FETCH_BASKET_DATA, REMOVE_FROM_BASKET } from "./actionTypes";

export const updateBasket =
	(currentLocation, productId, quantity) => (dispatch) => {
		const requestData = {
			location: currentLocation,
			product: productId,
			quantity: quantity,
		};

		return axios
			.post("/updatebasket", requestData)
			.then((response) => {
				//Dispatch Basket Data
				const basketData = response.data.data.basket.basket; //needs this extra .basket compared to fetch
				return dispatch({
					type: FETCH_BASKET_DATA,
					payload: basketData,
				});
			})
			.catch((err) => {
				console.log(
					"[Basket.actions.js] updateBasket || Could not add to basket. Try again later."
				);
			});
	};

export const fetchBasket = (currentLocationId, userId) => (dispatch) => {
	const requestData = {
		location: currentLocationId,
		user: userId,
	};

	return axios
		.post("/basket", requestData)
		.then((response) => {
			const basketData = response.data.data.basket;

			//Dispatch Basket Data
			return dispatch({
				type: FETCH_BASKET_DATA,
				payload: basketData,
			});
		})
		.catch((err) => {
			console.log(
				"[Basket.actions.js] fetchBasket || Could not fetch basket. Try again later."
			);
		});
};

export const removeFromBasket =
	(currentLocationId, basketItemId, basketData) => (dispatch) => {
		const requestData = {
			location: currentLocationId,
			id: basketItemId,
		};
		return axios
			.post("/remove_from_basket", requestData)
			.then((response) => {
				var resultBasket = basketData.slice(0);
				resultBasket.forEach(function (item, index, object) {
					if (item.id === basketItemId) {
						object.splice(index, 1);
					}
				});

				// Dispatch the new basket
				return dispatch({
					type: REMOVE_FROM_BASKET,
					payload: resultBasket,
				});
			})
			.catch((err) => {
				console.log(
					"[Basket.actions.js] removeFromBasket || Could not remove product from basket. Try again later."
				);
			});
	};

export const emptyBasket = (location_id) => {
	const requestData = {
		location: location_id,
	};
	return axios
		.post("/empty_basket", requestData)
		.then((response) => {
			window.location.reload(false);
		})
		.catch((err) => {
			console.log(
				"[Basket.actions.js] emptyBasket || Could not empty the basket. Try again later."
			);
		});
};
